import { UnexpectedError } from "src/components/UnexpectedError/UnexpectedError.tsx";

export const UnexpectedQueryError = ({
  error,
  onReset,
}: {
  error: unknown;
  onReset?: () => void;
}) => {
  return <UnexpectedError error={error} onReset={onReset} />;
};
